import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateDocument($companyId: ID!, $attributes: DocumentAttributes!) {
    createDocument(companyId: $companyId, attributes: $attributes) {
      document {
        id
        ...CreatedDocument
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedDocument on Document {
    id
    name
    reference
    dateIssued
    dateDue
    subject {
      ... on AssetType { id name }
      ... on Asset { id name }
      ... on Package { id name }
      ... on Event { id description }
    }
  }
`
